import React from "react";
import { useState, useEffect } from "react";

import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import moment from "moment";

import httpService from "services/httpService";
import BarChartLead from "components/Common/BarChartLead";
import StatusLeadPieChart from "components/Common/StatusLeadPieChart";
import PlatformLeadPieChart from "components/Common/PlatformLeadPieChart";
import ProvinceLeadPieChart from "components/Common/ProvinceLeadPieChart";
import Spacer from "components/Common/Spacing";
import VVSTable from "components/Common/VVSTable";
import { CommonButton } from "components/Common/ButtonCommon";
import SelectField from "components/form-control/Select";
import { GET_SUMMARY_LEAD } from "helpers/url_helper";

const ReportList = () => {
  const [dataCharts, setDataCharts] = useState({});
  const [totalLead, setTotalLead] = useState([]);
  const [dateFrom, setDateFrom] = useState(moment().format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [isFilter, setIsFilter] = useState(false);

  useEffect(() => {
    getDataSummarizeLead();
  }, []);

  const getDataSummarizeLead = async (startDate, endDate) => {
    try {
      if (isFilter) {
        var body = {
          dateFrom: startDate,
          dateTo: endDate,
        };
      } else {
        body = {
          dateFrom: moment().startOf("year").format("YYYY-MM-DD"),
          dateTo: moment().endOf("year").format("YYYY-MM-DD"),
        };
      }
      const res = await httpService.post(GET_SUMMARY_LEAD, body);
      if (res && res.result && res.result.code === 201) {
        setDataCharts(res.result.data);
        const newLeadArray = [...res.result.data.leadGroupByMonth];
        const result = newLeadArray.reduce((acc, current) => {
          let data = current.count + acc;
          return data;
        }, 0);
        setTotalLead(result);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // Filter lead by month
  const onClickFilter = () => {
    const payload = {
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
    };
    const startDate = moment(payload.dateFrom).format("YYYY-MM-DD");
    const endDate = moment(payload.dateTo).format("YYYY-MM-DD");
    setIsFilter(true);
    getDataSummarizeLead(startDate, endDate);
  };

  const { leadGroupByStatus } = dataCharts;

  return (
    <React.Fragment>
      <div className="report-list">
        <Container fluid>
          <Row>
            <Col xl={6} lg={6} xs={12}>
              <Card>
                <CardBody className="card-body-height">
                  <CardTitle className="mb-2">
                    Số lượng khách hàng tiềm năng mới theo tháng
                  </CardTitle>
                  <CardTitle className="mb-3">
                    Tổng số khách hàng tiềm năng: {totalLead}
                  </CardTitle>
                  <CardTitle className="mb-5">
                    <input
                      type="date"
                      style={{
                        border: "1px solid #ced4da",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        color: "#495057",
                        marginRight: "8px",
                      }}
                      value={dateFrom}
                      onChange={e => setDateFrom(e.target.value)}
                    />
                    <input
                      type="date"
                      style={{
                        border: "1px solid #ced4da",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        marginRight: "8px",
                        color: "#495057",
                      }}
                      value={dateTo}
                      onChange={e => setDateTo(e.target.value)}
                    />
                    <div
                      style={{
                        marginRight: "18px",
                        marginTop: "14px",
                        display: "inline-block",
                      }}
                    >
                      <CommonButton level={0} onClick={() => onClickFilter()}>
                        Lọc
                      </CommonButton>
                    </div>
                  </CardTitle>
                  <BarChartLead dataCharts={dataCharts} />
                </CardBody>
              </Card>
            </Col>
            <Col xl={6} lg={6} xs={12}>
              <Card>
                <CardBody className="card-body-height">
                  <CardTitle className="mb-5">
                    BC lead theo trạng thái
                  </CardTitle>
                  <CardTitle className="mb-5">
                    {/* <SelectField 
                    options={}
                    name
                    /> */}
                    <div
                      style={{
                        marginRight: "18px",
                        marginTop: "14px",
                        display: "inline-block",
                      }}
                    >
                      <CommonButton level={0} onClick={() => onClickFilter()}>
                        Lọc
                      </CommonButton>
                    </div>
                  </CardTitle>
                  <StatusLeadPieChart dataCharts={leadGroupByStatus} />
                </CardBody>
              </Card>
            </Col>
            <Col xl={6} lg={6} xs={12}>
              <Card>
                <CardBody className="card-body-height">
                  <CardTitle className="mb-5">BC lead theo nguồn</CardTitle>
                  <PlatformLeadPieChart dataCharts={dataCharts} />
                </CardBody>
              </Card>
            </Col>
            <Col xl={6} lg={6} xs={12}>
              <Card>
                <CardBody className="card-body-height">
                  <CardTitle className="mb-5">BC lead theo khu vực</CardTitle>
                  <ProvinceLeadPieChart dataCharts={dataCharts} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Spacer size={50} />
        {/* <Container fluid>
          <VVSTable
            showExportExcel
            disableAdd
            disableSearch
            disableDelete
            title="Báo cáo Lead"
            name="Lead"
            // whereQuery={queryFilter}
            // onTableChangeHandler={onTableChangeHandler}
          />
        </Container> */}
      </div>
    </React.Fragment>
  );
};

export default ReportList;
